import './TopBar.css';
import { DefaultButton } from '@fluentui/react/lib/Button';
import { Toggle } from '@fluentui/react/lib/Toggle';
import { Icon } from '@fluentui/react/lib/Icon';
import { GlobalStateContext } from '../../../contexts/GlobalState';
import { globalStateActionType } from '../../../contexts/GlobalState/reducer';
import { useContext } from 'react';

/**
 * A top bar header element with a sign out button
 * @returns a header element
 */
export const TopBar = () => {
    const [state, dispatch] = useContext(GlobalStateContext);
//    const navigate = useNavigate();

    async function signOut() {
        //set auth type
        dispatch({
            type: globalStateActionType.SIGNOUT
        });

//        navigate({ pathname: '/' });
        //msLogout();
    }

    function toggleDarkMode() {
        dispatch({
            type: globalStateActionType.TOGGLE_DARK_MODE
        });
    }

    return (
        <header className="cw-TopBar">
            <div className="cw-NavButton"></div>
            {state.identityToken && state.accessToken ?
                <div className="cw-TopBar-Controls">
                    <div className="cw-DarkModeToggle">
                        <Icon iconName={state.isDarkMode ? "ClearNight" : "Sunny"} className="cw-DarkModeToggle-Icon" />
                        <Toggle
                            checked={state.isDarkMode}
                            onChange={toggleDarkMode}
                            onText="Dark"
                            offText="Light"
                            inlineLabel
                        />
                    </div>
                    <div className="cw-UserProfileButton">
                        <DefaultButton
                            text="Sign Out"
                            onClick={signOut}
                        />
                    </div>
                </div>
                :
                null
            }
        </header>
    );
}
